import type { HTMLAttributes, ReactNode } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const iconBox = cva('inline-flex items-center justify-center rounded-md', {
  variants: {
    size: {
      sm: 'size-7',
      md: 'size-8',
      lg: 'size-10',
    },
    tone: {
      neutral: 'bg-surface2 text-text-2',
      accent: 'bg-[var(--accent-soft)] text-accent',
      solid: 'bg-accent text-[var(--on-solid)]',
      ok: 'bg-[color-mix(in_oklab,var(--ok)_10%,transparent)] text-[var(--success-fg)]',
      warn: 'bg-[color-mix(in_oklab,var(--warning)_10%,transparent)] text-[var(--warning-fg)]',
      danger:
        'bg-[color-mix(in_oklab,var(--danger)_10%,transparent)] text-[var(--danger-fg)]',
      info: 'bg-[color-mix(in_oklab,var(--info)_10%,transparent)] text-[var(--info-fg)]',
    },
  },
  defaultVariants: { size: 'md', tone: 'neutral' },
});

export interface IconBoxProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof iconBox> {
  children: ReactNode;
}

export function IconBox({ size, tone, className, children, ...rest }: IconBoxProps) {
  return (
    <span className={cn(iconBox({ size, tone }), className)} {...rest}>
      {children}
    </span>
  );
}
